import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from "react";
import loader from "./loader";
import shallowCompare from "shallow-compare";

var EnsureResources =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(EnsureResources, _React$Component);

  function EnsureResources(props) {
    var _this;

    _this = _React$Component.call(this) || this;
    var location = props.location,
        pageResources = props.pageResources;
    _this.state = {
      location: _objectSpread({}, location),
      pageResources: pageResources || loader.loadPageSync(location.pathname)
    };
    return _this;
  }

  EnsureResources.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var location = _ref.location;

    if (prevState.location.href !== location.href) {
      var pageResources = loader.loadPageSync(location.pathname);
      return {
        pageResources: pageResources,
        location: _objectSpread({}, location)
      };
    }

    return null;
  };

  var _proto = EnsureResources.prototype;

  _proto.loadResources = function loadResources(rawPath) {
    var _this2 = this;

    loader.loadPage(rawPath).then(function (pageResources) {
      if (pageResources && pageResources.status !== "error") {
        _this2.setState({
          location: _objectSpread({}, window.location),
          pageResources: pageResources
        });
      } else {
        window.history.replaceState({}, "", location.href);
        window.location = rawPath;
      }
    });
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    // Always return false if we're missing resources.
    if (!nextState.pageResources) {
      this.loadResources(nextProps.location.pathname);
      return false;
    } // Check if the component or json have changed.


    if (this.state.pageResources !== nextState.pageResources) {
      return true;
    }

    if (this.state.pageResources.component !== nextState.pageResources.component) {
      return true;
    }

    if (this.state.pageResources.json !== nextState.pageResources.json) {
      return true;
    } // Check if location has changed on a page using internal routing
    // via matchPath configuration.


    if (this.state.location.key !== nextState.location.key && nextState.pageResources.page && (nextState.pageResources.page.matchPath || nextState.pageResources.page.path)) {
      return true;
    }

    return shallowCompare(this, nextProps, nextState);
  };

  _proto.render = function render() {
    return this.props.children(this.state);
  };

  return EnsureResources;
}(React.Component);

export default EnsureResources;